import { render, staticRenderFns } from "./CreateCollection.vue?vue&type=template&id=3a87f13d&scoped=true&"
import script from "./CreateCollection.vue?vue&type=script&lang=ts&"
export * from "./CreateCollection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a87f13d",
  null
  
)

export default component.exports